import {Component, EventEmitter, Input, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from "rxjs";
import {MatSliderChange} from "@angular/material/slider";
import {ModeratRequestService} from "../services/request.service";
import {ModeratAnfrage} from "../anfrage/moderat.anfrage";
import {UntypedFormGroup} from "@angular/forms";


@Component({
  selector: 'app-sanierung-invest',
  templateUrl: './sanierung-invest.component.html'
})
export class SanierungInvestComponent implements OnInit, OnDestroy {

  /**
   * the configuration of the costs we want to display
   */
  @Input() costs: any;

  /**
   * eventmemitter that is fired every time the costs changes, so we can update the component.
   */
  @Input() costChanges: EventEmitter<any>;

  /**
   * remember the subscriptions so we can unsubscribe after leaving the component.
   */
  subscriptions: Subscription[] = [];

  /**
   * the maximum needed equity
   */
  maxEquity: number = 0;

  /**
   * Steps of the equity slider
   */
  sliderStep: number = 1;

  /**
   * toggle for the help of extra equity
   */
  showHelp: boolean = false;

  /**
   * holds the current users anfrage
   */
  anfrage: ModeratAnfrage;

  /**
   * formgroup holding teh formelements of all measures
   */
  @Input() form: UntypedFormGroup;

  /**
   * name of the current formfield
   */
  @Input() formField: string;

  /**
   * constructor
   * @param requestService
   */
  constructor(protected requestService: ModeratRequestService) {}

  /**
   * @inheritDoc
   */
  ngOnInit(): void {
    this.anfrage = this.requestService.getAnfrage();

    this.subscriptions.push(
      this.costChanges.subscribe(costs => {
        this.costs = costs;
        this.maxEquity = Math.max(costs.overall.sum - costs.funding_grants.sum - costs.promotional_loan.sum, 0);
        // reduce the selected equity if we need less
        if(this.maxEquity < this.anfrage.eigenkapital) {
          this.anfrage.eigenkapital = this.maxEquity;
          this.saveAnfrage();
        }

        // set steps of the slider depending on max equity
        if(this.maxEquity > 100000) {
          this.sliderStep = 1000;
        }
        else if(this.maxEquity > 10000) {
          this.sliderStep = 100;
        }
        else if(this.maxEquity > 1000) {
          this.sliderStep = 10;
        }
      })
    );
  }

  /**
   * @inheritDoc
   */
  ngOnDestroy() {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

  /**
   * validates the equity after it was changed (by user), set between min and max
   */
  validateEquity(): void {
    if(this.anfrage.eigenkapital < 0) {
      this.anfrage.eigenkapital = 0;
    }
    if(this.anfrage.eigenkapital > this.maxEquity) {
      this.anfrage.eigenkapital = this.maxEquity;
    }

    // save changed data
    this.saveAnfrage();
  }

  /**
   * save changes on the equity on the local storage an on the server.
   */
  saveAnfrage(): void {
    // use the change cost emitter to trigger recaultion with changed equity
    this.costChanges.emit(this.costs);

    // save changed data
    this.requestService.setAnfrage(this.anfrage);
    this.requestService.backendService.saveData(this.anfrage);
  }
}
